import React from 'react';

export const getStatusClassAndText = (status) => {
  switch (status) {
    case 'WAITING':
      return { class: 'bg-waiting', text: 'WAITING' };
    case 'RUNNING':
      return { class: 'bg-warning', text: 'RUNNING' };
    case 'COMPLETED':
      return { class: 'bg-primary', text: 'COMPLETED' };
    case 'FAILED':
      return { class: 'bg-danger', text: 'FAILED' };
    case 'INAPPLICABLE':
      return { class: 'bg-warning-badge', text: 'DISABLED' };
    case 'STOPPING':
      return { class: 'bg-danger', text: 'STOPPING' };
    default:
      return { class: 'bg-secondary', text: 'NOT BEGUN' };
  }
};

export const StatusBadge = ({ status, fullWidth = false }) => {
  const statusInfo = getStatusClassAndText(status);
  return (
    <span className={`badge ${fullWidth ? 'w-100' : ''} ${statusInfo.class}`}>
      {statusInfo.text}
    </span>
  );
};

export const StatusBadgeSm = ({ status, fullWidth = false }) => {
  const statusInfo = getStatusClassAndText(status);
  return (
    <span className={`badge  badge-sm ${fullWidth ? 'w-100' : ''} ${statusInfo.class}`} >
      {statusInfo.text}
    </span>
  );
};

export const StatusBadgeXSm = ({ status, fullWidth = false}) => {
  const statusInfo = getStatusClassAndText(status);
  return (
    <span className={`badge badge-xsm ${fullWidth ? 'w-100' : ''} ${statusInfo.class}`} >
      {statusInfo.text}
    </span>
  );
}; 